import { FORM_VALUE_ENUM, FORM_VALUE_INTER } from './constant';

export const convert = (data: FORM_VALUE_INTER): FORM_VALUE_INTER => {
  const rawEmail = data?.[FORM_VALUE_ENUM.EMAIL];

  return {
    ...data,
    email: typeof rawEmail === 'string' ? rawEmail.trim().toLowerCase() : '',
  };
};

export const convertArray = (
  array: string[] | null | any,
  viewObj: Record<string, string>,
) =>
  array
    ? array.map((e: number) => ({
        label: viewObj[Number(e)],
        value: Number(e),
      }))
    : null;
